import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import HeroSection from "../sections/HeroSection";
import SkillsSection from "../sections/SkillsSection";
import SuccessSection from "../sections/SuccessSection";
import ProjectsSection from "../sections/ProjectsSection";
import MailSection from "../sections/MailSection";
import "../styles/sections/hero.css";
import "../styles/sections/projects.css";
import "../styles/sections/skills.css";
import "../styles/sections/success.css";

export default function Home() {
  return (
    <>
      <Navbar />
      <div>
        <HeroSection />
        <SkillsSection />
        <SuccessSection />
        <ProjectsSection />
        <MailSection />
      </div>
      <Footer />
    </>
  );
}
